export const SYSTEM_TYPE = {
  EHR: 'EHR',
  PM_BILLING: 'PM/Billing',
} as const;
